import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import HyperFocus from "../../HyperFocus/Views/HyperFocus";
import { menuItems, MenuItemID, PROFILE_MENU_ITEM, DISPLAY_MENU_ITEM } from "../utils/mySettingsMenu";
import { ProfileSection } from "./ProfileSection";
import { DisplaySection } from "./DisplaySection";
import { MobileMySettings } from './MobileMySettings';
import { useIsMobile } from '../../../hooks/useIsMobile';

export interface Props {
  show: boolean;
  handleShowModal: () => void;
}

export const MySettings = ({ show, handleShowModal }: Props) => {
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState<MenuItemID>(PROFILE_MENU_ITEM);
  const isMobile = useIsMobile();

  const handleMenuItemClick = (menuItem: MenuItemID) => {
    const target = document.getElementById(menuItem);
    target?.scrollIntoView({ behavior: "smooth" });
    setActiveMenu(menuItem);
  }
  const modalClass = isMobile ? "my-settings-mobile" : "my-settings-modal";
  return (
    <>
      <HyperFocus
        hideModalHeader={isMobile}
        handleShowModal={handleShowModal}
        title={t("mySettings.title")}
        show={show}
        className={modalClass}
      >
        {isMobile ? (
          <MobileMySettings
            show={show}
            handleShowModal={handleShowModal}
          />
        ) : (
          <div
            className="app-settings__modal"
            data-testid="my-settings-modal"
          >
            <div
              className="app-settings__sidebar"
              data-testid="app-settings__sidebar"
            >
              {menuItems.map((item) => (
                <div
                  key={item.id}
                  className="sidebar--second-level"
                  data-testid={`my-settings-menu-item-${item.id}`}
                  onClick={() => handleMenuItemClick(item.id)}
                >
                  <div className={`sidebar--second-level-item ${activeMenu === item.id ? "is-active" : ""}`}>
                    <i className={`icon ${item.icon}`} />
                    <span>{t(item.title)}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="app-settings__content scrollbar-visible">
              <div
                id={PROFILE_MENU_ITEM}
                data-testid={PROFILE_MENU_ITEM}
                className="my-settings__content-body"
              >
                <ProfileSection />
              </div>
              <div
                id={DISPLAY_MENU_ITEM}
                data-testid={DISPLAY_MENU_ITEM}
                className="my-settings__content-body"
              >
                <DisplaySection />
              </div>
            </div>
          </div>
        )}

      </HyperFocus>
    </>
  );
};
